import { Loader2 } from 'lucide-react';
import { cn } from '../../lib/utils';

interface SpinnerProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  label?: string;
}

export function Spinner({ className, size = 'md', label }: SpinnerProps): JSX.Element {
  const sz = { sm: 'h-3 w-3', md: 'h-4 w-4', lg: 'h-6 w-6' }[size];
  return (
    <output className={cn('inline-flex items-center gap-2 text-ink-muted', className)}>
      <Loader2 className={cn('animate-spin', sz)} aria-hidden="true" />
      {label ? <span className="text-sm">{label}</span> : null}
      {!label ? <span className="sr-only">Loading</span> : null}
    </output>
  );
}
